
import { Button, Divider, Dropdown, MenuProps, Space } from 'antd';
import './PrivateHeaderComponent.scss'
import { useTranslation } from 'react-i18next';
import { DownOutlined, EditOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, SmileOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { GetFormattedUrl } from '../../../utils/urls';
import { createAvatar } from '@dicebear/core';
import { identicon } from '@dicebear/collection';
import { useSessionData } from '../../../Contexts/SessionDataContext';
import HTMLReactParser from 'html-react-parser';
import { CurrencySelector, LanguageSelector } from '..';
import CommissionConfigurationSelector from '../CommissionConfigurationSelector/CommissionConfigurationSelector';

interface PrivateHeaderComponentProps {
    toogleCollapse: () => void,
    doLogout: () => void
}

const PrivateHeaderComponent = (props: PrivateHeaderComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const appConfig = useAppConfig();
    const loginSessionData = useSessionData();

    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

    const { toogleCollapse, doLogout } = props;

    const onToogleCollapse = (): void => {
        setIsCollapsed(!isCollapsed);
        toogleCollapse();
    }

    const goDashboard = (): void => {
        navigate(GetFormattedUrl('private/dashboard'));
    }

    const onDoLogout = (): void => {
        doLogout();
    }

    const goProfile = (): void => {
        navigate(GetFormattedUrl('private/profile'));
    }

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <div className="my-profile-link" onClick={goProfile}>
                    <EditOutlined className="menu-icon" /> {t('components.private-header-component.my-profile-link')}
                </div>
            ),
        },
        {
            type: 'divider',
        },
        {
            key: '2',
            label: (
                <div className="close-session-link" onClick={onDoLogout}>
                    <LogoutOutlined className="menu-icon" /> {t('components.private-header-component.close-session-link')}
                </div>
            ),
        }
    ];

    const [currencies, setCurrencies] = useState<MenuProps['items']>([] as MenuProps['items']);

    const [avatarImage, setAvatarImage] = useState<string>('');

    useEffect(() => {
        if (appConfig.config.availableLanguages) {
            //<Select.Option disabled={!l.enabled} key={l.shortCode}>{l.description}</Select.Option>
            const availableCurrencies: MenuProps['items'] = appConfig.config.availableCurrencies.map((c, index) => {
                return {
                    key: `${c.iso}`,
                    label: (
                        <div className="language-item">
                            <span className="language-name">{c.iso}</span>
                        </div>
                    ),
                }
            });
            setCurrencies(availableCurrencies);
        }
    }, [])

    useEffect(() => {
        if (loginSessionData) {
            const avatar = createAvatar(identicon, {
                seed: loginSessionData.userData.email,
                // ... other options
            });

            if (avatar) {
                setAvatarImage(avatar.toString());
            }
        }


    }, [loginSessionData])


    return (
        <header className="private-header-component">
            <div className="logo">
                <div>
                    {
                        isCollapsed ? <MenuUnfoldOutlined onClick={onToogleCollapse} className="btn-collapse-menu app-icon" /> : <MenuFoldOutlined onClick={onToogleCollapse} className="btn-collapse-menu app-icon" />
                    }
                </div>
                <img onClick={goDashboard} src={appConfig.config.images.appLogo} />
            </div>

            <div className="user-menu">
                {
                    appConfig.device !== "mobile" ?
                        <div className="commission-configuration-selector">
                            <CommissionConfigurationSelector />
                        </div>
                        :
                        null
                }
                {
                    appConfig.device !== "mobile" ?
                        <div className="language-selector">
                            <LanguageSelector />
                        </div>
                        :
                        null
                }

                {
                    appConfig.device !== "mobile" ?
                        <div className="currency-selector">
                            <CurrencySelector />
                        </div>
                        :
                        null
                }




                <div className="user-actions">
                    <div className="avatar">
                        <div className="avatar-image">
                            {
                                loginSessionData?.userData?.avatar ? <img src={loginSessionData?.userData?.avatar} /> : HTMLReactParser(avatarImage)
                            }
                        </div>
                    </div>
                    <span className="user-name">
                        <Dropdown menu={{ items, style: { borderRadius: "3px" } }} trigger={['click']}>
                            <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                    {
                                        appConfig.device !== "mobile" ?
                                            <span className="name-container">
                                                {loginSessionData?.userData?.name} {loginSessionData?.userData?.surname} {loginSessionData?.userData?.secondSurname}
                                            </span>
                                            : null
                                    }
                                    <DownOutlined className="arrow-icon" />
                                </Space>
                            </a>
                        </Dropdown>

                    </span>
                </div>
            </div>
        </header>
    )
}

export default PrivateHeaderComponent;